import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { resetExistingSalaryConfig } from '../api/salaryApi';

class DefaultLink extends Component {
	constructor() {
		super();

		this.onClick = this.onClick.bind(this);
	}

	async onClick(e) {
		if (this.props.itemProps.hasSubMenu) {
			this.props.itemProps.toggleSubMenu(e);
		} else {
			if (this.props.itemProps.label === 'Edit Salary') {
				await this.props.resetExistingSalaryConfig();
			}
			this.props.itemProps.activateMe({
				newLocation: this.props.to,
				selectedMenuLabel: this.props.label
			});

		}
	}
	render() {
		const { itemProps } = this.props;
		if (itemProps.id === 'Extra') {
			return (
				<span className="g_heading">
					{itemProps.label}
				</span>
			);
		} else {
			return (
				<NavLink to={`${itemProps.to}`} onClick={this.onClick} className={`metismenu-link`}>
					<i className={itemProps.children[0].props.className}></i>
					<span>{itemProps.label}</span>
					<i className={itemProps?.children[2]?.props?.className}></i>
				</NavLink>
			);
		}
	}
};
const mapStateToProps = state => ({
	subMenuIcon: state.settings.isSubMenuIcon,
	menuIcon: state.settings.isMenuIcon
})

const mapDispatchToProps = dispatch => ({
	resetExistingSalaryConfig: () => dispatch(resetExistingSalaryConfig())
})
export default connect(mapStateToProps, mapDispatchToProps)(DefaultLink);